<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-4 col-md-12 col-2 mb-3">
                            <h2>Dashboard </h2>
                        </div>
                        <div class="col-lg-8 col-6 text-right">
                            <form class="form-inline justify-content-end">
                                <div class="form-group mb-2 right">
                                    <label for="staticEmail2" class="col-form-label mr-2 text-white">Year: </label>
                                     <select v-model="selectedYear" @change="changeMonthOrYear()" class="form-control w100p" aria-label="Default select example">
                                        <option v-for="year in years" :key="year">{{year}}</option>
                                    </select>
                                </div>
                                <div class="form-group mb-2 right">
                                    <label for="staticEmail2" class="col-form-label mr-2 text-white">Month: </label>
                                     <select v-model="selectedMonth" @change="changeMonthOrYear()" class="form-control w100p" aria-label="Default select example">
                                        <option v-for="month in months" :key="month">{{month}}</option>
                                    </select>
                                </div>
                                <div  class="form-group mb-2 right">
                                    <button :disabled="plUploadStatus == 'INPROGRESS'"  class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <div v-if="plUploadStatus == 'INPROGRESS'" style="color:black">
                                            <i class="fa fa-spinner fa-spin"></i>  IMPORTING..
                                        </div> 
                                        <div v-if="!plUploadStatus">
                                            <i class="fas fa-upload"></i>  IMPORT
                                        </div>  
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item cursor-pointer" @click="openImportPLModal('RECENT')">RECENT FILE</a>
                                        <a class="dropdown-item cursor-pointer" @click="openImportPLModal('PREVIOUS')">PREVIOUS FILE</a>
                                        <a class="dropdown-item cursor-pointer" @click="openImportPLModal('CLEAR & REIMPORT')">CLEAR & REIMPORT</a>
                                    </div>
                                    <!-- <button type="button" class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i v-if="exporting" class="fa fa-spinner fa-spin"></i> 
                                        <i v-if="!exporting" class="fas fa-file-download"></i> 
                                        {{'EXPORT'}}
                                    </button> 
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item cursor-pointer" @click="exportPnl()" >
                                            <i v-if="exporting" class="fa fa-spinner fa-spin"></i>   Trade Profit Report
                                        </a>
                                        <a class="dropdown-item cursor-pointer" @click="openImportPLModal('PREVIOUS')">PREVIOUS FILE</a>
                                    </div>              -->
                                </div>  
                                <div class="form-group mb-2 right">
                                    <button type="button" class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" id="exportDropdownButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i v-if="exporting" class="fa fa-spinner fa-spin"></i> 
                                        <i v-else class="fas fa-file-download"></i> 
                                        {{'EXPORT'}}
                                    </button> 
                                    <div class="dropdown-menu" aria-labelledby="exportDropdownButton">
                                        <a class="dropdown-item cursor-pointer" @click="exportPnl()">
                                          Trade Profit Report
                                        </a>
                                        <a class="dropdown-item cursor-pointer" @click="exportUnsettled()">Unsettled Trades Report</a>
                                    </div>             
                                </div>  
                            </form>
                               
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard bidside" >
            <div class="row">
                <div class="col-xl-12">
                    <div class="row">
                        <div class="col-xl-4" v-if="isAdmin || isEditor || isSuperAdmin">
                            <div class="card maturityR pl">
                                <div class="card-header bg-transparent">
                                    <div class="row align-items-center">
                                        <div class="col orange">
                                            <h3><i class="fas fa-dollar-sign"></i>Wealthscape/ Trading Profit</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body repcodes">
                                    <ul>
                                        <li v-if="repLoading" >
                                            <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                        </li>  
                                        <li v-if="!repLoading && Object.keys(repCodeSum).length == 0"  >
                                            <h4>No Data Found </h4>
                                        </li>  
                                        <li v-for="(data,i) in repCodeSum" :key="'B'+ i">
                                            <div class="d-flex justify-content-between w-80">
                                                <div class="repchild">
                                                    <!-- <span>Wealthscape</span> -->
                                                    <span class="amt text-primary"> {{data.fieldName}}</span>
                                                </div>
                                                <div class="repchild">
                                                    <!-- <span>Trading Profit</span> -->
                                                    <span data-toggle="tooltip" data-placement="left"  title="Latest Wealthscape Value entered." v-if="(data.fieldName != 'Trading Profit' && data.fieldName != 'Off-Board Transactions') && data.fieldValue !== null"  class="amt text-success"> {{data.fieldValue | currency}}</span>
                                                    <span data-toggle="tooltip" data-placement="left"  title="Aggregate of Wealthscape value entered." v-if="(data.fieldName == 'Off-Board Transactions') && data.fieldValue !== null"  class="amt text-success"> {{data.fieldValue | currency}}</span>
                                                    <span v-if="data.fieldName != 'Trading Profit' && data.calculatedValue !== null && data.fieldValue !== null"  >/</span>
                                                    <span data-toggle="tooltip" data-placement="left" v-if="data.calculatedValue !== null" v-bind:title="data.tooltipText"  class="amt text-warning">{{data.calculatedValue | currency}}</span>
                                                </div>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                                
                                <!-- <div class="card-footer">
                                    <a href="#"><i class="fas fa-chevron-circle-right"></i>View More</a>
                                </div> -->
                            </div>
                            <div style="margin-top:10px">
                            <div class="card">
                                <div class="card-body repcodes">
                                    <ul>
                                        <!-- <li v-if="repLoading" >
                                            <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                        </li>   -->
                                        <li v-if="!repLoading && Object.keys(salesCredit).length == 0"  >
                                            <h4>No Data Found </h4>
                                        </li>  
                                        <li v-for="(data,i) in salesCredit" :key="'A'+ i">
                                            <div class="d-flex justify-content-between w-80">
                                                <div class="repchild">
                                                    <span class="amt text-primary"> {{data.fieldName}}</span>
                                                </div>
                                                <div class="repchild">
                                                    <span class="amt text-success"> {{data.fieldValue | currency}}</span>
                                                    
                                                    
                                                </div>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                    </div>  
                        </div>
                        <div class="col-md-8">
                            <div class="row">
                                <div v-if="isAdmin || isEditor || isSuperAdmin" class="col-xl-5">
                                    <div class="card maturityR pl">
                                        <div class="card-header bg-transparent">
                                            <div class="row align-items-center">
                                                <div class="col violet">
                                                    <h3><i class="fas fa-coins"></i>Cumulative Breakdown (Revenue) </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            
                                            <div v-if="cubreakLoding" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                              
                                            <div class="d-flex justify-content-around">
                                                <div class="cumulative">
                                                    <router-link class="cursor-pointer" :to="{ name: 'profitandlosslist', query: { transactionType: 'Sales Credit',fromdate:fromDate,todate:toDate}}">
                                                        <span class="text-primary"><i class="far fa-credit-card"></i>Sales Credit</span>
                                                    </router-link>
                                                    <span class="amt text-dark"> {{revenueByRepCode.salesCredit | currency}}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-around">
                                                <div class="cumulative">
                                                    <router-link class="cursor-pointer" :to="{ name: 'profitandlosslist', query: { transactionType: 'Trade Profit',fromdate:fromDate,todate:toDate }}">
                                                        <span class="text-primary"><i class="fas fa-hand-holding-usd"></i>Trade Profit</span>
                                                    </router-link>     
                                                    <span class="amt text-dark"> {{revenueByRepCode.tradeProfit | currency}}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-around">
                                                <div class="cumulative">
                                                    <router-link class="cursor-pointer" :to="{ name: 'profitandlosstrademapping', query: { transactionType: 'Off-Board Transactions',fromdate:fromDate,todate:toDate,isSettiled:true }}">
                                                        <span class="text-primary"><i class="fas fa-exchange-alt"></i>Off-board transactions</span>
                                                    </router-link>    
                                                    <span class="amt text-dark">{{revenueByRepCode.offBoardTransactions | currency}}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-around" v-for="(commission) in revenueByRepCode.commissions" :key="commission.commissionName">
                                                <div class="cumulative">
                                                    <router-link class="cursor-pointer" :to="{ name: 'profitandlosslist', query: { transactionType: commission.commissionName,fromdate:fromDate,todate:toDate }}">
                                                        <span class="text-primary"><i class="far fa-handshake"></i>{{commission.commissionName }}</span>
                                                    </router-link>    
                                                    <span class="amt text-dark">{{commission.amount  | currency}}</span>
                                                </div>
                                            </div>
                                            <!-- <div class="d-flex justify-content-around">
                                                <div class="cumulative">
                                                    <router-link class="cursor-pointer" :to="{ name: 'profitandlosslist', query: { transactionType: 'JP Commissions',fromdate:fromDate,todate:toDate }}">
                                                        <span class="text-primary"><i class="fa fa-dollar-sign"></i>Jp Commissions</span>
                                                    </router-link>    
                                                    <span class="amt text-dark">{{revenueByRepCode.jpCommissionsSum | currency}}</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-around">
                                                <div class="cumulative">
                                                    <router-link class="cursor-pointer" :to="{ name: 'profitandlosslist', query: { transactionType: 'RS Commissions',fromdate:fromDate,todate:toDate }}">
                                                        <span class="text-primary"><i class="fa fa-calculator"></i>Rs Commissions</span>
                                                    </router-link>    
                                                    <span class="amt text-dark">{{revenueByRepCode.rsCommissionsSum | currency}}</span>
                                                </div>
                                            </div> -->
                                        </div>
                                        <div class="card-footer">
                                            TOTAL: <h4> {{revenueByRepCode.total | currency}}</h4>
                                        </div>
                                    </div>
                                </div>

                            <div v-if="isAdmin || isTrader || isSuperAdmin || isEditor" class="col-xl-7">
                                <div class="card maturityR">
                                    <div class="card-header bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col green">
                                                <h3><i class="far fa-money-bill-alt"></i>Trader Breakdown</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body TBreakdown-body">
                                        <!--<div v-if="traderBreakLoding" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                        <div class="d-flex justify-content-around" v-if="!traderBreakLoding && Object.keys(revenueByTrader).length == 0"  >
                                            <h4>No Data Found </h4>
                                        </div>
                                        <div v-for="(data ,i) in revenueByTrader" :key="'C'+ i" class="d-flex justify-content-around">
                                            <div class="cumulative tb">
                                                <router-link class="text-primary cursor-pointer" :to="{ name: 'profitandlosslist', query: { traderId: data.traderId,fromdate:fromDate,todate:toDate, }}">
                                                    <span class="text-primary"><i class="fas fa-user text-info"></i>{{data.firstName}}</span>
                                                </router-link>
                                                <span class="amt text-dark">SC <b>{{data.salesCredit | currency}}</b></span>
                                                <span class="amt text-dark">Trading Profit <b>{{data.tradeProfit | currency}}</b></span>
                                                <span class="amt text-dark">Commissions <b class="text-primary cursor-pointer" @click="showCommission(data)">
                                                   View
                                                </b>
                                                </span>
                                                
                                            </div>-->
                                            <!-- <div>
                                                <span v-for="(commission) in data.commissions" :key="commission" class="text-dark">{{commission.commissionName}} <b>{{commission.amount | currency}}</b></span>

                                            </div>
                                        </div> -->
                                        <div v-if="traderBreakLoding" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                        <div class="d-flex justify-content-around" v-if="!traderBreakLoding && Object.keys(revenueByTrader).length == 0"  >
                                            <h4>No Data Found </h4>
                                        </div>
                                        <table class="table table-striped table-bordered TBreakdown" v-if="Object.keys(revenueByTrader).length != 0">
                                            <thead>
                                                <!-- <tr>
                                                    <th></th>
                                                    <th colspan="4">commissions</th>
                                                </tr> -->
                                                <tr>
                                                <th scope="col" rowspan="2">Trader</th>
                                                <th scope="col" rowspan="2" class="text-right">SC</th>
                                                <th scope="col" rowspan="2" class="text-right">TP</th>
                                                <th scope="col" colspan="3" class="text-center">Commissions</th>
                                                <!-- <th scope="col" rowspan="2" class="text-center">Action</th> -->
                                                
                                                <!-- <th scope="col" class="text-right">More</th> -->
                                                </tr>
                                                <tr>
                                                    <th scope="col" rowspan="2" class="text-right">RS</th>
                                                    <th scope="col" rowspan="2" class="text-right">JP</th>
                                                    <th scope="col" class="text-right"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(data ,i) in revenueByTrader" :key="'C'+ i" >
                                                <td scope="row">
                                                    <router-link class="text-primary cursor-pointer" :to="{ name: 'profitandlosslist', query: { traderId: data.traderId,fromdate:fromDate,todate:toDate, }}">
                                                        {{data.firstName}}
                                                    </router-link>
                                                </td>
                                                <td class="text-right text-info">{{data.salesCredit | currency}}</td>
                                                <td class="text-success text-right">{{data.tradeProfit | currency}}</td>
                                                <td class="text-right" ><span class="text-dark">{{data.commissions.length ? (data.commissions.find(c => c.commissionName == 'RS Commissions').amount) : 0  | currency}}</span></td>
                                                <td class="text-right"><span class="text-dark">{{data.commissions.length ? (data.commissions.find(c => c.commissionName == 'JP Commissions').amount ) : 0 | currency}}</span></td>
                                                <td class="text-center"><span v-bind:class="{'disabled': !data.moreButtonEnable}" @click="showCommission(data)" class="text-primary cursor-pointer">More</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        
                                    </div>
                                    <div class="card-footer tb">
                                        <b>TOTAL: </b>
                                        <div class="sc-wrap">
                                            <span>SC <h4 class="text-info">{{salesCreditTotal | currency}}</h4></span>
                                            <span>Trading Profit <h4 class="text-success">{{tradeProfitTotal | currency}}</h4></span>
                                            <!-- <span>Off-Board<h4 class="text-success">{{totalOffBoard | currency}}</h4></span> -->
                                        </div>
                                        <div class="sc-wrap" >
                                            <span v-for="(commission) in traderCommissions" :key="'F'+commission.commissionName">{{commission.commissionName}} <h4 class="text-dark">{{commission.amount | currency}}</h4></span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row" v-if="isAdmin || isEditor || isSuperAdmin">
                <div class="col-xl-12">
                    <div class="col-xl-4" style="padding-left:0px">
                        <div class="card">
                        <div class="card-body repcodes">
                            <ul>
                                <li v-if="repLoading" >
                                    <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                </li>  
                                <li v-if="!repLoading && Object.keys(salesCredit).length == 0"  >
                                    <h4>No Data Found </h4>
                                </li>  
                                <li v-for="(data,i) in salesCredit" :key="'A'+ i">
                                    <div class="d-flex justify-content-between w-80">
                                        <div class="repchild">
                                            <span class="amt text-primary"> {{data.fieldName}}</span>
                                        </div>
                                        <div class="repchild">
                                            <span class="amt text-success"> {{data.fieldValue | currency}}</span>
                                            
                                            
                                        </div>
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                        </div>
                    </div>    
                </div>
            </div> -->
        </div>
        <plmodal
            v-if="plModalOpen"
            v-bind:plType="plType" 
            @close="closeImportPLModal()"
        ></plmodal>
    </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import plmodal from "./ImsProfitLossImportModal";

export default {
  name: "ImsProfitLossDashboard",
   components: {
    plmodal
  },
  data() {
    return {
      selectedYear : localStorage.getItem('selectedyear') ? localStorage.getItem('selectedyear') :new Date().getFullYear(),
      selectedMonth : localStorage.getItem('selectedmonth') ? localStorage.getItem('selectedmonth') : this.moment().format('MMMM'),
      years : [],
      months : this.moment.months(),
      loading : false,
      revenueByRepCode : {},
      revenueByTrader : {},
      repCodeSum : {},
      salesCredit : {},
      salesCreditTotal : 0,
      tradeProfitTotal : 0,
      totalOffBoard : 0,
      plModalOpen : false,
      repLoading : false,
      cubreakLoding : false,
      traderBreakLoding : false,
      isAdmin : false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      currentUserRoles : [],
      exporting : false,
      fromDate : null,
      toDate : null,
      plUploadStatus : localStorage.getItem("PLUPLOADSTATUS"),
      traderCommissions : null,
      commissions : [],
      plType : 'RECENT'

    };
  },
  methods: {
    showCommission(data){
        if(!data.moreButtonEnable) return;
        let message = "<table class='table table-striped TBreakdown'>";
        message += `<tr><td class="text-left">Sales Credit </td><td class="text-right text-success"> $ ${new Intl.NumberFormat('en-US').format(data.salesCredit)}</td></tr>`;
        message += `<tr><td class="text-left">Trade Profit </td><td class="text-right text-success"> $ ${new Intl.NumberFormat('en-US').format(data.tradeProfit)}</td></tr>`;
        data.commissions.forEach((commission) =>{
            if(!commission.commissionName.includes('Commissions')) commission.commissionName += " Commissions";
            message += `<tr><td class="text-left">${commission.commissionName}</td><td class="text-right text-success">$ ${new Intl.NumberFormat('en-US').format(commission.amount)}</td>`
        });
        message += "</table>"
        // console.log(message)
        this.$fire({
            title: "<strong>"+data.firstName+"</strong>",
            html: message,
            confirmButtonText: "Close",

          })
    },
    getMonthSetting(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .get(config.baseUrlBidSide + 
            "/pnl/month-settings-list?year="+this.selectedYear,
            auth
        )
        .then((result) => {
            result.data.forEach(data => {
                if(data.month == this.selectedMonth){
                    this.fromDate = data.startDate
                    this.toDate =  data.endDate
                }
            })
            // console.log(this.fromDate, this.toDate)                         
        })
    },
    openImportPLModal(type){
        this.getPLRemapStatus().then((result) => {
            if(result.data.remapOngoing){
                this.$alert(this.appMessages.plRemapMessage,"","warning");              
            }else{
                this.plType = type;
                this.plModalOpen = true;
            }
        })
         
    },
    closeImportPLModal(){
        this.plModalOpen = false;
        this.plUploadStatus = localStorage.getItem("PLUPLOADSTATUS");
    },
    getYears(){
        let currentYear = new Date().getFullYear() + 1;
        for (var i = currentYear; i > currentYear - 10; i--) {
                this.years.push(i);   
        }
    },
    changeMonthOrYear(){
        this.getRevenueByRepcode();
        this.getRepCodeSum();
        this.getRevenueByTrader();
        this.getMonthSetting();
        localStorage.setItem('selectedyear', this.selectedYear);
        localStorage.setItem('selectedmonth', this.selectedMonth);
    },
    getRevenueByRepcode(){
        this.cubreakLoding = true;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/revenue-by-rep-code?year="+this.selectedYear+"&month="+this.selectedMonth,
            auth
        )
        .then(result => {
          this.revenueByRepCode = result.data;
          this.cubreakLoding = false;

          
        })       
    },
    getRevenueByTrader(){
        this.traderBreakLoding = true;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let url = "/pnl/revenue-by-trader?year="+this.selectedYear+"&month="+this.selectedMonth+"&cognitoSub="+authService.getUser().cognitoSub;
        // if(this.isTrader && !this.isAdmin && !this.isEditor && !this.isSuperAdmin){
        //     url += "&cognitoSub="+authService.getUser().cognitoSub;
        // }
        this.$http
        .get(
           config.baseUrlBidSide +
            url,
            auth
        )
        .then(result => {
        //   this.revenueByTrader = result.data.revenueMap;
          this.salesCreditTotal = result.data.totalSalesCredit;
          this.tradeProfitTotal = result.data.totalTradeProfit;
          this.totalOffBoard = result.data.totalOffBoard;
          this.traderCommissions   = result.data.commissions;

          let rev = result.data.revenueMap;
          for (const property in rev) {
            rev[property].commissions.forEach(data =>{
                if(!data.commissionName.includes("RS") && !data.commissionName.includes("RS")){
                    if(data.amount > 0) rev[property].moreButtonEnable = true
                }
                
            })
            }
            console.log(rev)

          this.revenueByTrader = rev;   

        //   this.revenueByTrader.forEach((data) =>{
        //     data.commissionTooltipText = "test"
        //   })
        //   let rev = result.data.revenueMap
        //   for (const property in rev) {
        //     let toolTipText = "";
        //     rev[property].commissions.forEach(data =>{
        //         toolTipText += data.commissionName+':'+data.amount;
        //     })
        //     rev[property].commissionTooltipText = toolTipText
        //   console.log(rev)
        //   this.revenueByTrader = rev;   
        // console.log(this.revenueByTrader[property].commissions);
        //}

        //   for (let data in this.revenueByTrader) {
        //     data.commissionTooltipText = "test"
            
        //     }
          this.traderBreakLoding = false;
        })       
    },
    getRepCodeSum(){
        this.repLoading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/wealth-summary?year="+this.selectedYear+"&month="+this.selectedMonth,
            auth
        )
        .then(result => {
          this.repCodeSum = this.getFormattedResponse(result.data)
          this.salesCredit = this.getFormattedResponseSalesCredit(result.data)
          this.repLoading = false;
        })
        .catch(() => {
        //   console.log(e);
          this.repCodeSum = [];
          this.salesCredit = [];
          this.repLoading = false;
        });       
    },
    getFormattedResponse(welthSum){
        let resArray = []
        welthSum.forEach((data) =>{
           if(data.fieldName == 'Account Balance') resArray.push(data);
        })
        welthSum.forEach((data) =>{
           if(data.fieldName.includes('Revenue')) {
                data.tooltipText = "Monthly calculated SC"
                resArray.push(data);
            }
        })
        welthSum.forEach((data) =>{
           if(this.commissions.includes(data.fieldName) ){
                data.tooltipText = "Monthly calculated Commissions"
                resArray.push(data);
           }
        //    if(data.fieldName == 'JP') {
        //         data.tooltipText = "Monthly calculated JP"
        //         resArray.push(data);
        //    }
           if(data.fieldName == 'Off-Board Transactions'){
                data.tooltipText = "Monthly calculated Off-Board Transactions"
                resArray.push(data);
           } 
           if(data.fieldName.includes('Off-Board Transactions (')){
                data.tooltipText = "Monthly calculated Off-Board Transactions"
                resArray.push(data);
           } 
           if(data.fieldName == 'Trading Profit'){
                resArray.push(data);
           } 
        })
        return resArray;

    },
    getFormattedResponseSalesCredit(welthSum){
        let resArray = []
        welthSum.forEach((data) =>{
           if(data.fieldName == 'EOD Sales Credit') resArray.push(data);
        })
        welthSum.forEach((data) =>{
           if(data.fieldName == 'Wealthscape Daily Sales Credit') resArray.push(data);
        });
        if(resArray.length > 1){
            let obj = {fieldName : "Difference",fieldValue : (resArray[0].fieldValue - resArray[1].fieldValue)}
            resArray.push(obj);
        }
        return resArray;

    },
    exportUnsettled(){
      this.exporting = true;  
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let expUrl = "/pnl/unsettled-trades-report?cognitoSub="+authService.getUser().cognitoSub;
      this.$http
        .get(
           config.baseUrlAutoBidder + expUrl,
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.exporting = false; 
         
        })
        .catch(() => {
          //console.log(e);
          this.exporting = false; 

        });
    },
    exportPnl(){
      this.exporting = true;  
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let expUrl = "/pnl/download?year="+this.selectedYear+"&month="+this.selectedMonth +"&userRole="+this.currentUserRoles.toString()+"&cognitoSub="+authService.getUser().cognitoSub;
    //   if(this.isTrader && !this.isAdmin && !this.isEditor && !this.isSuperAdmin){
    //         expUrl += "&cognitoSub="+authService.getUser().cognitoSub;
    //     }
      this.$http
        .get(
           config.baseUrlBidSide + expUrl,
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.exporting = false; 
         
        })
        .catch(() => {
          //console.log(e);
          this.exporting = false; 

        });
    },
    getCommissions(){
        this.repLoading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/pnl/commissions",
            auth
        )
        .then(result => {
          this.commissions = result.data.map((data) => {return data.commissionName});
          this.getRepCodeSum();
        })        
    },
    
  },
  mounted() {
    this.getYears();
    this.getRevenueByRepcode();
    // this.getRepCodeSum();
    this.getRevenueByTrader();
    this.getMonthSetting();
    this.getCommissions();

    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          });
          this.currentUserRoles = roleArray;
        //   console.log(this.currentUserRoles)
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
        //console.log("isa",this.isAdmin);
      });
    this.$root.$on("PLUPLOADCOMPLETED", () => {
      this.plUploadStatus = null;
    });  
  }
};
</script>
<style>
 .card a {
    float: none;
    margin-top : 0px;
 }
 h4 {
    color : #5e72e4 !important
 }
 .bidside .card{
    height: auto;
 }
</style>